/* tslint:disable */
/* eslint-disable */
/**
 * Bank Accounts API
 * API for managing bank accounts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SelectRibForDevisCommand
 */
export interface SelectRibForDevisCommand {
    /**
     * ID of the quote
     * @type {string}
     * @memberof SelectRibForDevisCommand
     */
    devisId: string;
    /**
     * ID of the selected bank account (must have a DocumentId attached)
     * @type {string}
     * @memberof SelectRibForDevisCommand
     */
    compteBancaireId: string;
}

/**
 * Check if a given object implements the SelectRibForDevisCommand interface.
 */
export function instanceOfSelectRibForDevisCommand(value: object): value is SelectRibForDevisCommand {
    if (!('devisId' in value) || value['devisId'] === undefined) return false;
    if (!('compteBancaireId' in value) || value['compteBancaireId'] === undefined) return false;
    return true;
}

export function SelectRibForDevisCommandFromJSON(json: any): SelectRibForDevisCommand {
    return SelectRibForDevisCommandFromJSONTyped(json, false);
}

export function SelectRibForDevisCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): SelectRibForDevisCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'devisId': json['devisId'],
        'compteBancaireId': json['compteBancaireId'],
    };
}

export function SelectRibForDevisCommandToJSON(json: any): SelectRibForDevisCommand {
    return SelectRibForDevisCommandToJSONTyped(json, false);
}

export function SelectRibForDevisCommandToJSONTyped(value?: SelectRibForDevisCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'devisId': value['devisId'],
        'compteBancaireId': value['compteBancaireId'],
    };
}

